import { useEffect, useState, useSyncExternalStore } from "react";
import {
  isLoaderVisible,
  subscribeLoader,
} from "components/LoaderRenderer/loaderStore";

/**
 * True once the global loader has stayed hidden for `settleMs`. The settle
 * window rides over the short gaps between back-to-back loading gates
 * (auth → config → route chunk → page data).
 */
export const useLoaderSettled = (settleMs: number) => {
  const isVisible = useSyncExternalStore(subscribeLoader, isLoaderVisible);
  const [isSettled, setIsSettled] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsSettled(false);
      return undefined;
    }
    const timer = setTimeout(() => setIsSettled(true), settleMs);
    return () => clearTimeout(timer);
  }, [isVisible, settleMs]);

  return isSettled;
};
